// multiFileSelectHooks.js - Custom hooks for multi-file selection functionality
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { selectFilteredFile } from "./index";

/**
 * Hook for multi-file selection functionality
 */
export const useMultiFileSelect = () => {
  const dispatch = useDispatch();

  // Select file for multi-file selection
  const handleSelectFile = useCallback(
    (caseId, clipId, audioFile) => {
      return dispatch(selectFilteredFile({ caseId, clipId, audioFile }));
    },
    [dispatch],
  );

  return {
    // Actions
    selectFilteredFile: handleSelectFile,
  };
};
